var _g, _circle, _circle2, _g2, _circle3, _circle4, _g3, _circle5, _circle6, _g4, _circle7, _circle8, _g5, _circle9, _circle10, _g6, _circle11, _circle12, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationOrchestration = function SvgIllustrationOrchestration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 160,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-orchestration_svg__a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__b)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 105,
    r: 9.5,
    stroke: "#F5C0C0"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__c)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 105,
    r: 4,
    fill: "#634F69",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 105,
    r: 4,
    fill: "url(#illustration-orchestration_svg__d)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 105,
    r: 3.5,
    stroke: "#F5C0C0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__e)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 143,
    r: 9.5,
    stroke: "#F5C0C0"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__f)"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 143,
    r: 4,
    fill: "#634F69",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 143,
    r: 4,
    fill: "url(#illustration-orchestration_svg__g)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 143,
    r: 3.5,
    stroke: "#F5C0C0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__h)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 148,
    r: 9.5,
    stroke: "#F5C0C0"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__i)"
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 148,
    r: 4,
    fill: "#634F69",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 148,
    r: 4,
    fill: "url(#illustration-orchestration_svg__j)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 148,
    r: 3.5,
    stroke: "#F5C0C0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__k)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 150,
    r: 9.5,
    stroke: "#F5C0C0"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__l)"
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 150,
    r: 4,
    fill: "#634F69",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 150,
    r: 4,
    fill: "url(#illustration-orchestration_svg__m)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 150,
    r: 3.5,
    stroke: "#F5C0C0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__n)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 127,
    r: 9.5,
    stroke: "#F5C0C0"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__o)"
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 127,
    r: 4,
    fill: "#634F69",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 127,
    r: 4,
    fill: "url(#illustration-orchestration_svg__p)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 127,
    r: 3.5,
    stroke: "#F5C0C0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__q)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 98,
    r: 9.5,
    stroke: "#F5C0C0"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-orchestration_svg__r)"
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 98,
    r: 4,
    fill: "#634F69",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 98,
    r: 4,
    fill: "url(#illustration-orchestration_svg__s)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 98,
    r: 3.5,
    stroke: "#F5C0C0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-orchestration_svg__t)",
    d: "M97.666 134.472a.5.5 0 0 0 .306-.638l-1.494-4.245a.5.5 0 0 0-.944.332l1.328 3.773-3.773 1.328a.5.5 0 0 0 .332.944zm-60.882-29.021 60.5 29 .432-.902-60.5-29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-orchestration_svg__u)",
    d: "M95.883 144.822a.5.5 0 0 0-.061-.705l-3.445-2.896a.501.501 0 0 0-.643.766l3.062 2.574-2.575 3.062a.5.5 0 1 0 .766.643zm-52.34 4.676 52-4.5-.086-.996-52 4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-orchestration_svg__v)",
    d: "M209.854 147.354a.5.5 0 0 0 0-.708l-3.182-3.182a.502.502 0 0 0-.708.708l2.829 2.828-2.829 2.828a.502.502 0 0 0 .708.708zM127 144c-.151.477-.15.477-.149.477l.001.001.003.001.01.002.029.009.109.029c.095.024.24.058.448.1.415.084 1.082.203 2.105.345 2.047.283 5.529.659 11.286 1.035 11.516.751 32.153 1.501 68.658 1.501v-1c-36.495 0-57.108-.75-68.592-1.499-5.743-.374-9.199-.748-11.214-1.028a33 33 0 0 1-2.043-.334 10 10 0 0 1-.486-.112l-.015-.004-.002-.001.001.001h.001z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-orchestration_svg__w)",
    d: "M158.435 130.247a.5.5 0 0 0-.188-.682l-3.915-2.22a.5.5 0 0 0-.493.87l3.479 1.973-1.973 3.48a.5.5 0 0 0 .87.493zm-38.302 10.735 38-10.5-.266-.964-38 10.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-orchestration_svg__x)",
    d: "M248.946 102.226a.5.5 0 0 0-.22-.672l-4.016-2.032a.5.5 0 0 0-.451.893l3.569 1.805-1.805 3.57a.5.5 0 1 0 .892.451zm-64.29 21.249 64-21-.312-.95-64 21z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-orchestration_svg__y)",
    d: "M263.854 112.646a.5.5 0 0 0-.708 0l-3.182 3.182a.502.502 0 0 0 .708.708l2.828-2.829 2.828 2.829a.502.502 0 0 0 .708-.708zM239 145.5l.181.466.002-.001.004-.001.015-.006.055-.022.211-.087c.184-.077.452-.192.792-.347a44 44 0 0 0 2.807-1.407c2.319-1.262 5.413-3.187 8.508-5.84C257.765 132.949 264 124.698 264 113h-1c0 11.302-6.015 19.301-12.075 24.495-3.03 2.597-6.061 4.484-8.336 5.722a44 44 0 0 1-2.743 1.375c-.33.15-.589.261-.764.335l-.199.081-.049.02-.012.005-.002.001h-.001z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__d",
    x1: 36,
    x2: 36,
    y1: 100.09,
    y2: 109.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__g",
    x1: 110,
    x2: 110,
    y1: 138.09,
    y2: 147.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__j",
    x1: 225,
    x2: 225,
    y1: 143.09,
    y2: 152.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__m",
    x1: 29,
    x2: 29,
    y1: 145.09,
    y2: 154.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__p",
    x1: 172,
    x2: 172,
    y1: 122.09,
    y2: 131.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__s",
    x1: 263,
    x2: 263,
    y1: 93.09,
    y2: 102.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__t",
    x1: 80.5,
    x2: 69.218,
    y1: 124,
    y2: 133.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__u",
    x1: 89,
    x2: 43,
    y1: 142.5,
    y2: 148.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__v",
    x1: 209,
    x2: 193.497,
    y1: 146.5,
    y2: 177.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__w",
    x1: 152.872,
    x2: 152.924,
    y1: 128.984,
    y2: 139.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__x",
    x1: 249,
    x2: 242.072,
    y1: 105.5,
    y2: 136.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-orchestration_svg__y",
    x1: 264,
    x2: 274.335,
    y1: 111,
    y2: 134.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__b",
    width: 52,
    height: 52,
    x: 10,
    y: 87,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__c",
    width: 40,
    height: 40,
    x: 16,
    y: 93,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__e",
    width: 52,
    height: 52,
    x: 84,
    y: 125,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__f",
    width: 40,
    height: 40,
    x: 90,
    y: 131,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__h",
    width: 52,
    height: 52,
    x: 199,
    y: 130,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__i",
    width: 40,
    height: 40,
    x: 205,
    y: 136,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__k",
    width: 52,
    height: 52,
    x: 3,
    y: 132,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__l",
    width: 40,
    height: 40,
    x: 9,
    y: 138,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__n",
    width: 52,
    height: 52,
    x: 146,
    y: 109,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__o",
    width: 40,
    height: 40,
    x: 152,
    y: 115,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__q",
    width: 52,
    height: 52,
    x: 237,
    y: 80,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-orchestration_svg__r",
    width: 40,
    height: 40,
    x: 243,
    y: 86,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_893_20622",
    result: "effect2_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_893_20622",
    result: "effect3_dropShadow_893_20622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_893_20622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-orchestration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h300v160H0z"
  })))));
};
export { SvgIllustrationOrchestration as ReactComponent };
export default __webpack_public_path__ + "static/illustration-orchestration.bd75c8ec.svg";